<div
  class="bob-toast-card-host"
  [ngClass]="'bob-toast-card-host--' + payload.color"
  [class.bob-toast-card-host--bottom]="payload.position === 'bottom'"
  [class.bob-toast-card-host--top]="payload.position === 'top'"
  aria-live="polite"
>
  <div
    class="toast-alert"
    [class.toast-alert--clickable]="payload.clickable"
    [attr.role]="payload.clickable ? 'button' : 'alert'"
    [attr.tabindex]="payload.clickable ? 0 : null"
    (click)="onCardActivate()"
    (keydown.enter)="onCardKeydown($event)"
    (keydown.space)="onCardKeydown($event)"
  >
    <div class="toast-alert__icon" aria-hidden="true">
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path
          d="M12 9v4M12 17h.01M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
        />
      </svg>
    </div>

    <div class="toast-alert__body">
      <div class="toast-alert__head">
        <p class="toast-alert__title">{{ payload.title }}</p>
        <!--         <!-- <span class="toast-alert__badge" *ngIf="payload.badge">{{
          payload.badge
        }}</span> -->
      </div>
      <p class="toast-alert__text" *ngIf="payload.message">{{ payload.message }}</p>
    </div>

    <button
      *ngIf="payload.showClose"
      type="button"
      class="toast-alert__close"
      [attr.aria-label]="'BOB_TOAST.CLOSE' | translate"
      (click)="close(); $event.stopPropagation()"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path d="M18 6 6 18M6 6l12 12" />
      </svg>
    </button>
  </div>
</div>
